import keys from "locale/keys";
import { useTranslation } from "react-i18next";

import AmazonLogo from "../../../assets/brands/Amazon.png";
import StarbucksLogo from "../../../assets/brands/Starbuck.png";
import UberLogo from "../../../assets/brands/Uber.png";
import {
  BrandLogoBox,
  BrandLogoImage,
  BrandsBannerSection,
  BrandsBannerSubtitle,
  BrandsBannerTitle,
  BrandsLogoRow,
} from "./styled.components";

const BRAND_LOGOS = [
  { src: UberLogo, alt: "Uber" },
  { src: AmazonLogo, alt: "Amazon", blend: true },
  { src: StarbucksLogo, alt: "Starbucks" },
];

const BrandsBanner = () => {
  const { t } = useTranslation();

  return (
    <BrandsBannerSection>
      <BrandsBannerTitle>{t(keys.brands_banner_title)}</BrandsBannerTitle>
      <BrandsBannerSubtitle>
        {t(keys.brands_banner_subtitle)}
      </BrandsBannerSubtitle>
      <BrandsLogoRow>
        {BRAND_LOGOS.map((brand) => (
          <BrandLogoBox key={brand.alt}>
            <BrandLogoImage
              src={brand.src}
              alt={brand.alt}
              blend={brand.blend}
            />
          </BrandLogoBox>
        ))}
      </BrandsLogoRow>
    </BrandsBannerSection>
  );
};

export default BrandsBanner;
